import { Form } from "react-bootstrap";
import { Field, ErrorMessage, useFormikContext } from "formik";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const PhoneNumberField = ({
  name = "phone_number",
  placeholder = "+44",
  defaultCountry = "GB",
  maxLength = 15,
}) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Form.Group>
      {/* <Form.Label>{label}</Form.Label> */}
      {/* <div className="commn-no-input mb-3"> */}
      <Field name={name}>
        {({ field, form }) => (
          <PhoneInput
            international
            placeholder={placeholder}
            value={field.value}
            countryCallingCodeEditable={false}
            defaultCountry={defaultCountry}
            maxLength={maxLength}
            onChange={(value) => {
              form.setFieldValue(name, value);
              setFieldValue(name, value);
            }}
            name={name}
          />
        )}
      </Field>
      {/* </div> */}
      <ErrorMessage name={name} component="div" className="text-danger" />
    </Form.Group>
  );
};

export default PhoneNumberField;
